import {createFileRoute} from '@tanstack/react-router';
import {
  DepositAccountMonthlyDepositCallbackPage,
  MonthlyDepositCallbackAction,
} from 'features/deposit/monthlyDeposit/DepositAccountMonthlyDepositCallbackPage';

export const Route = createFileRoute('/_protected/monthly-deposit/callback')({
  component: DepositAccountMonthlyDepositCallbackPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
      status: search.status as string | undefined,
      action: search.action as MonthlyDepositCallbackAction | undefined,
      amount: search.amount as string | undefined,
      day: search.day as string | undefined,
    };
  },
});
